import { render } from "./Bestellen.vue?vue&type=template&id=37893cc4&scoped=true"
import script from "./Bestellen.vue?vue&type=script&lang=js"
export * from "./Bestellen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend-bocholt\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37893cc4"]])

export default __exports__